import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dfc34d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "down-layout" }
const _hoisted_2 = { class: "down-aa" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ctrl-more" }, [
  /*#__PURE__*/_createCommentVNode(" <ui-icon type=\"update\" /> ")
], -1 /* HOISTED */))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "temp-option" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_group_option = _resolveComponent("ui-group-option")!
  const _component_ui_group = _resolveComponent("ui-group")!
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ui_group, {
        title: _ctx.$t('coord.download'),
        borderBottom: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_group_option, null, {
            default: _withCtx(() => [
              _createVNode(_component_ui_input, {
                type: "select",
                placeholder: _ctx.$t('sys.selectPic'),
                options: $setup.options.filter(item => item.show.value),
                modelValue: $setup.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.type) = $event)),
                width: "100%"
              }, null, 8 /* PROPS */, ["placeholder", "options", "modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          ($setup.coordOptions.length)
            ? (_openBlock(), _createBlock(_component_ui_group_option, {
                key: 0,
                class: "head-ctrl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_input, {
                    type: "checkbox",
                    label: $setup.ui18n.t('sys.all'),
                    modelValue: $setup.linkTree.select,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.linkTree.select) = $event))
                  }, null, 8 /* PROPS */, ["label", "modelValue"]),
                  _hoisted_3
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createVNode(_component_ui_group, { class: "list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coordOptions, (option, j) => {
            return (_openBlock(), _createBlock(_component_ui_group_option, {
              class: "option",
              onClick: ($event: any) => ($setup.fly(j, option))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createCommentVNode(" {{ linkTree.children[j]?.current || \"u\" }} "),
                  _createVNode(_component_ui_input, {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    type: "checkbox",
                    modelValue: $setup.linkTree.children[j]?.select,
                    "onUpdate:modelValue": v => ($setup.linkTree.children[j].select = v),
                    class: "checkbox"
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                  _createElementVNode("span", _hoisted_4, [
                    (option.icon)
                      ? (_openBlock(), _createBlock(_component_ui_icon, {
                          key: 0,
                          type: option.icon
                        }, null, 8 /* PROPS */, ["type"]))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString(option.label), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", null, [
                  (option.append)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(option.append), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_ui_input, {
      class: "file-input",
      width: "100%",
      accept: ".xls",
      "onUpdate:modelValue": $setup.uploadHandler,
      ref: "fileInput",
      type: "file"
    }, null, 512 /* NEED_PATCH */),
    _createVNode(_component_ui_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_ui_group_option, null, {
          default: _withCtx(() => [
            ($setup.tempOption.length > 1)
              ? (_openBlock(), _createBlock(_component_ui_input, {
                  key: 0,
                  class: "temp-select",
                  type: "select",
                  unplaceholder: _ctx.$t('sys.unData'),
                  options: $setup.tempOption,
                  placeholder: _ctx.$t('sys.selectPic'),
                  modelValue: $setup.temp,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.temp) = $event)),
                  width: "100%",
                  dire: "top"
                }, {
                  option: _withCtx(({ raw }) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", null, [
                        (raw.value === $setup.uploadId)
                          ? (_openBlock(), _createBlock(_component_ui_icon, {
                              key: 0,
                              type: "uploading"
                            }))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("span", null, _toDisplayString(raw.label), 1 /* TEXT */)
                      ]),
                      (![$setup.defaultCoordTempId, $setup.uploadId].includes(raw.value))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createCommentVNode(" <ui-icon type=\"del\" @mousedown=\"delHandler(raw)\" /> ")
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  icon: _withCtx(() => [
                    _createCommentVNode(" <ui-icon\n              type=\"download\"\n              small\n              ctrl\n              :class=\"{ disabled: !temp }\"\n              @click.stop=\"downloadTemp\"\n            /> "),
                    _createVNode(_component_ui_icon, {
                      type: "pull-down",
                      small: "",
                      class: "pull-down"
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["unplaceholder", "options", "placeholder", "modelValue"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_ui_button, {
              class: _normalizeClass(["start-measure", { disabled: !$setup.temp || !$setup.linkTree.selects.length }]),
              type: "primary",
              onClick: $setup.download,
              style: {"margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('coord.szDownload')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class", "onClick"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    })
  ]))
}